exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-statistics-sessions__content[data-v-6510e748] {\n  font-size: 18px;\n}", ""]);

// exports
